// $( document ).ready(function() {
//   window.addEventListener('reel-plus-add-to-cart-main:loaded', function() {
//     if (!moved) moveReviews();
//   });
// });

document.addEventListener('DOMContentLoaded', function () {


    (function () {
    const CONTAINER_SELECTOR = '.reel-plus-carousel-widget';
    const TARGET_SELECTOR = '.reel-plus-add-to-cart-main';
    let hasApplied = false;

    // function applyCustomStyles(targetEl) {
    //     if (hasApplied) return;
    //     hasApplied = true;

    //     // Add a class so your CSS file can style it
    //     targetEl.classList.add('my-reel-plus-custom');

    //     console.log('Reel Plus widget loaded — custom styles applied');
    // }

    function applyCustomStyles() {
        const targets = document.querySelectorAll(TARGET_SELECTOR);
        if (targets.length === 0) return false;

        targets.forEach(function (el) {
            el.classList.add('my-reel-plus-custom');
        });

        console.log('Reel Plus widget loaded — styles applied to', targets.length, 'elements');
        return true;
    }

    function checkExisting() {
        const el = document.querySelector(TARGET_SELECTOR);
        if (el) {
        applyCustomStyles(el);
        return true;
        }
        return false;
    }

    const container = document.querySelector(CONTAINER_SELECTOR);

    if (!container) {
        console.warn('Reel Plus container not found on page:', CONTAINER_SELECTOR);
        return;
    }

    // 1. Check immediately in case it's already loaded
    if (!checkExisting()) {
        // 2. Watch the container for the widget injecting its content
        const observer = new MutationObserver((mutations, obs) => {
        if (checkExisting()) {
            obs.disconnect(); // stop watching once the widget has loaded
        }
        });

        observer.observe(container, {
        childList: true,
        subtree: true
        });
    }
    })();

});
document.addEventListener("DOMContentLoaded", function () { const currentPath = window.location.pathname.replace(/\/$/, ""); document.querySelectorAll(".m-menu__link--main").forEach(link => { const linkPath = new URL(link.href).pathname.replace(/\/$/, ""); if (linkPath === currentPath) { link.classList.add("active"); } }); });